import {
  selectFinancialYear,
  selectPartnerAccess,
  selectPartnerId,
  selectProgramType,
} from 'legacy/lut/features/partner360/configuration'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import {
  getKeyInitiativesTagId,
  KEY_INITIATIVES_TAG,
  keyInitiativesApi,
} from 'partner360/entities/keyInitiatives'
import { Requirements } from 'partner360/features/keyInitiatives'

import { invalidateFinancialCockpitData } from '../../../../model/financialCockpitSlice'
import { selectCockpitCurrency, selectCockpitMetric } from '../../../../model/selectors'
import { selectCockpitRequirementsFinancialData } from '../../../../model/selectors/selectCockpitRequirementsFinancialData'

export const PartnerRequirements = () => {
  const dispatch = useAppDispatch()
  const partnerId = useSelector(selectPartnerId)
  const programType = useSelector(selectProgramType)
  const fYear = useSelector(selectFinancialYear)
  const { isGlobal } = useSelector(selectPartnerAccess)
  const activeCurrency = useSelector(selectCockpitCurrency)
  const actualsType = useSelector(selectCockpitMetric)
  const finData = useSelector(selectCockpitRequirementsFinancialData)
  const refreshInitiatives = useCallback(() => {
    dispatch(
      keyInitiativesApi.util.invalidateTags([
        {
          type: KEY_INITIATIVES_TAG,
          id: getKeyInitiativesTagId({ partnerId, fYear, programType }),
        },
      ])
    )
    dispatch(invalidateFinancialCockpitData())
  }, [dispatch, partnerId, fYear, programType])

  return (
    <Requirements
      partnerId={partnerId}
      programType={programType}
      isGlobal={isGlobal}
      finData={finData}
      activeCurrency={activeCurrency}
      actualsType={actualsType}
      refetchKI={refreshInitiatives}
      onInitiativeCreate={refreshInitiatives}
      onInitiativesCopied={refreshInitiatives}
    />
  )
}
